var _style, _circle, _g, _circle2, _path, _path2, _g2, _g3, _g4, _path3, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIldlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.3 24.3",
    style: {
      enableBackground: "new 0 0 24.3 24.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#58595B;stroke-width:0.3478;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#231F20;stroke-width:0.1739;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st2{fill:none;stroke:#231F20;stroke-width:0.1739;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:0,0,0.1722,0.3443;}\n\t.st3{fill:#231F20;}\n\t.st4{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st6{opacity:0.7;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:0.3478;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.3478;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:0.1739;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#231F20;stroke-width:0.1739;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#58595B;}\n\t.st13{fill:none;stroke:#58595B;stroke-width:0.1739;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 12.2,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.4,6.7C3.5,6.7,3.5,6.7,3.4,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.7,6.3c1.9-2.7,5-4.5,8.5-4.5s6.6,1.8,8.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.7,6.4C20.8,6.5,20.8,6.5,20.7,6.4"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 12.2,
    cy: 12.2,
    r: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.9,14.4l-0.2,0.2l0.2,0.2l0.3-0.2l0.1,0.1L15.2,15l0.2,0.1l0.2-0.2c0.1,0,0.1,0.1,0.2,0.1v0.3l0.3,0.1 l0.1-0.3c0.1,0,0.1,0,0.2,0l0.1,0.3h0.3v-0.3c0.1,0,0.1,0,0.2-0.1l0.2,0.3l0.2-0.1l-0.1-0.3c0.1,0,0.1-0.1,0.2-0.1l0.3,0.2l0.2-0.2 l-0.2-0.2c0,0,0-0.1,0.1-0.1c0,0,0,0,0-0.1l0.3,0.1l0.1-0.3L18,14c0-0.1,0-0.1,0-0.2h0.3v-0.3L18,13.4c0-0.1,0-0.1,0-0.2l0.3-0.1 L18,12.9L17.7,13c0-0.1-0.1-0.1-0.1-0.2l0.2-0.2l-0.2-0.2l-0.3,0.2l-0.1-0.1l0.1-0.3L17.2,12L17,12.2c-0.1,0-0.1,0-0.2-0.1v-0.3 l-0.3-0.1L16.4,12c-0.1,0-0.1,0-0.2,0l-0.1-0.3h-0.3V12c-0.1,0-0.1,0-0.2,0.1l-0.2-0.3L15.3,12l0.1,0.3l-0.1,0.1L15,12.3l-0.2,0.2 l0.2,0.3c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1l-0.3-0.1L14.5,13l0.3,0.2c0,0.1,0,0.1,0,0.2h-0.3v0.3l0.3,0.1c0,0.1,0,0.1,0,0.2l-0.3,0.1 l0.1,0.3L14.9,14.4C14.9,14.3,14.9,14.4,14.9,14.4L14.9,14.4z M17,14.6l-0.4-0.8l0.1-0.1h0.9c0,0.2-0.1,0.3-0.2,0.5 C17.2,14.4,17.1,14.6,17,14.6L17,14.6z M15.6,12.6l0.4,0.7c0,0,0,0.1-0.1,0.1h-0.8c0-0.1,0.1-0.3,0.2-0.4 C15.3,12.8,15.4,12.7,15.6,12.6L15.6,12.6z M15.4,14.5C15.2,14.3,15,14,15,13.7h0.8c0,0,0,0,0,0.1l0,0L15.4,14.5L15.4,14.5z  M16.4,13.8c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3s0.2,0,0.3,0.1C16.5,13.6,16.5,13.8,16.4,13.8z M15.8,12.5 c0.3-0.1,0.7-0.1,1,0l-0.5,0.7h-0.1L15.8,12.5L15.8,12.5z M16.6,13.4L16.6,13.4l0.5-0.7c0.2,0.2,0.4,0.5,0.4,0.8L16.6,13.4 C16.6,13.5,16.6,13.4,16.6,13.4L16.6,13.4z M16.7,14.8c-0.3,0.1-0.7,0.1-1-0.1l0.5-0.7c0,0,0.1,0,0.2,0C16.3,14,16.7,14.8,16.7,14.8 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.4,17.1l-0.2,0.2l0.2,0.2l0.2-0.2l0,0c0.1,0.1,0.2,0.1,0.3,0.1l0,0v0.3h0.2l0.1-0.3l0,0c0.1,0,0.2,0,0.3-0.1 l0,0l0.2,0.2l0.2-0.1l-0.1-0.2l0,0l0,0c0.1-0.1,0.1-0.2,0.2-0.2l0,0h0.3l0.1-0.2l-0.2-0.1l0,0c0-0.1,0-0.2,0-0.3l0,0l0.2-0.2 L18.2,16l-0.3,0.1l0,0c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.1l0,0l0.1-0.3l-0.2-0.1l-0.1,0.2l0,0c-0.1,0-0.2,0-0.3,0l0,0L17,15.4l-0.2,0.1 v0.3l0,0c-0.1,0-0.2,0.1-0.3,0.2l0,0l-0.3-0.1L16.1,16l0.2,0.2l0,0c-0.1,0.1-0.1,0.2-0.1,0.3l0,0l-0.3,0.1v0.2h0.3l0,0 C16.3,16.9,16.3,17,16.4,17.1L16.4,17.1L16.4,17.1z M17.6,16.1l-0.1,0.1c-0.2-0.1-0.4-0.1-0.6,0l-0.1-0.1 C16.9,15.9,17.3,15.9,17.6,16.1z M16.9,16.8c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4,0s0.1,0.3,0,0.4S17.1,17,16.9,16.8L16.9,16.8z  M16.7,16.9L16.6,17c-0.2-0.2-0.2-0.6,0-0.9l0.1,0.1C16.6,16.5,16.6,16.8,16.7,16.9z M17.7,17l-0.1-0.1c0.1-0.2,0.1-0.4,0-0.6 l0.1-0.1C17.9,16.4,17.9,16.8,17.7,17z M16.7,17.2l0.1-0.1c0.2,0.1,0.4,0.1,0.6,0l0.1,0.1C17.3,17.4,17,17.4,16.7,17.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.3,13.2c0,0.2-0.5,0.3-1.1,0.3s-1.1-0.1-1.1-0.3s0.5-0.3,1.1-0.3C12.8,13,13.3,13.1,13.3,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M15.2,19c0,0.3-1.3,0.5-3,0.5s-3-0.2-3-0.5s1.3-0.5,3-0.5S15.2,18.7,15.2,19z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "11.1,13.2 11.1,15.8 9.2,19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "13.3,13.2 13.3,15.7 15.2,19  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.2,11.6c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4C13,11.1,13.2,11.3,13.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,12.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2S12.1,12.1,12.1,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,13.2c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2S12.1,13,12.1,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11.9,14c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2C11.8,13.8,11.9,13.9,11.9,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.7,16.3c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2S12.7,16.2,12.7,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.7,15.6c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2S12.7,15.5,12.7,15.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 12.1,
    cy: 14.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.3,17.4c0,0.1,1.2,1.6,0.8,1.7c-0.7,0.3-2.6,0.4-3.1,0.4c-2,0-2.4-0.3-2.7-0.4s0.9-1.6,0.9-1.7 c0-0.2,1-0.4,2.1-0.4S14.3,17.2,14.3,17.4L14.3,17.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.2,17.4c0,0.2-0.9,0.3-2,0.3s-2-0.2-2-0.3c0-0.2,0.9-0.3,2-0.3S14.2,17.2,14.2,17.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 12.2,
    cy: 12.2,
    r: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.4,8.9l0.1-0.2l1.4,0.5v0.2L1.4,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.1,10.5v-0.2l1.5-0.5H2.5H2.4L1.3,9.6V9.4l1.5,0.3v0.2l-1.4,0.5h0.1h0.1l1,0.2v0.1L1.1,10.5L1.1,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1,11.5v-0.2l1.3,0.1V11h0.2l-0.1,1.1H2.2v-0.4L1,11.5L1,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.2,13.3H1l-0.1-1l1.5-0.1l0.1,1H2.3v-0.8H1.8V13H1.6v-0.6H1.1L1.2,13.3L1.2,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.3,14.9v-0.2l0.6-0.4l-0.1-0.4L1.1,14v-0.2l1.5-0.3l0.1,0.6c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2L1.3,14.9L1.3,14.9z M1.9,13.8L2,14.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0.1,0.2,0 c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2l-0.1-0.4L1.9,13.8L1.9,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.7,16.3l-0.1-0.2L2,15.8l-0.2-0.5H1.3l-0.1-0.2h1.6L3,15.3L1.7,16.3L1.7,16.3z M2.2,15.7l0.6-0.5H2L2.2,15.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.7,17.2v0.2c-0.3,0.1-0.6,0-0.7-0.3c0-0.1,0-0.3,0.1-0.5c0.1-0.2,0.2-0.3,0.4-0.4s0.4-0.1,0.6-0.1 c0.2,0,0.3,0.1,0.4,0.3c0.1,0.3,0.1,0.5-0.2,0.7L3.2,17c0.2-0.2,0.2-0.3,0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.2s-0.3,0-0.5,0.1 s-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.2,0,0.3C2.3,17.2,2.5,17.3,2.7,17.2L2.7,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.8,18.4l-0.1-0.2l1.1-0.7l-0.2-0.4L3.7,17l0.6,0.9L4.2,18L4,17.6C3.9,17.6,2.8,18.4,2.8,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.4,19.2L3.3,19l1.2-0.9l0.1,0.1L3.4,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.5,19.3L4,20l-0.1-0.1l0.8-1.4l0.1,0.1l-0.6,1.2L5.5,19.3L5.5,19.3L5.5,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,21.1l-0.1,0.1l-0.8-0.6l1-1.2L6.4,20l-0.1,0.1l-0.6-0.5L5.4,20l0.5,0.4l-0.1,0.1l-0.5-0.4L5,20.6 L5.6,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.3,22.1l-0.1,0.1l-0.8-0.4l0.7-1.3l0.2,0.1l-0.7,1.2L7.3,22.1L7.3,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.5,22.6l-0.1,0.2l-0.9-0.4L8.1,21L9,21.4v0.1l-0.7-0.3l-0.2,0.4l0.6,0.2L8.6,22L8,21.8l-0.2,0.5L8.5,22.6 L8.5,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.9,23.2l-0.2-0.1v-0.5l-0.5-0.1L9,22.9H8.8l0.9-1.3l0.2,0.1V23.2L9.9,23.2z M9.7,22.5v-0.8l-0.4,0.6 L9.7,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.3,23.4h-0.2l-0.2-0.7l-0.4-0.1l-0.1,0.7h-0.2l0.2-1.5l0.6,0.1c0.2,0,0.3,0.1,0.3,0.2 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1L11.3,23.4L11.3,23.4z M10.5,22.5l0.4,0.1 c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2s0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1l-0.4-0.1V22.5L10.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13,23.4h-0.2L12,22.1v0.1v0.1v1.1h-0.2v-1.5H12l0.8,1.2V23v-0.1v-1h0.1L13,23.4L13,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.7,23.3h-0.2l-0.2-1.5h0.2L13.7,23.3L13.7,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.3,23h-0.2L14,21.9V22v0.1l0.3,1.1h-0.1l-0.3-1.5l0.2-0.1l1,1v-0.1v-0.1l-0.2-1H15L15.3,23L15.3,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.6,21.7l0.3,0.7h-0.1l-0.1-0.2c0,0.2-0.1,0.3-0.3,0.3c-0.2,0.1-0.4,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.4-0.4 c-0.1-0.2-0.1-0.4-0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.4c0.3-0.1,0.5,0,0.7,0.2l-0.2,0.1c-0.1-0.1-0.1-0.2-0.2-0.2s-0.2,0-0.2,0 c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.3,0.1,0.5s0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.1,0.4,0c0.1,0,0.2-0.1,0.2-0.2s0-0.2,0-0.3 C16.7,21.9,16.7,21.9,16.6,21.7L16.2,22l-0.1-0.1L16.6,21.7L16.6,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.9,20.9L19,21c-0.1,0-0.1,0.1-0.1,0.1h-0.1c0,0-0.1,0-0.2,0c0,0.2-0.1,0.3-0.3,0.4 c-0.1,0.1-0.3,0.1-0.4,0.1s-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c-0.2-0.1-0.3-0.1-0.3-0.2 s-0.1-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.3,0,0.5l0.5,0.2 c0-0.2,0-0.3-0.1-0.5l0.2-0.1c0.1,0.2,0.1,0.4,0.1,0.6C18.8,20.9,18.8,20.9,18.9,20.9C18.8,21,18.9,21,18.9,20.9L18.9,20.9z  M17.8,20.7c0.1-0.1,0.1-0.2,0.1-0.3s0-0.1,0-0.1l-0.1-0.1c-0.1,0-0.1,0-0.2,0l-0.1,0.1v0.1C17.6,20.6,17.7,20.7,17.8,20.7 L17.8,20.7z M17.9,20.9c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.1,0.1,0.2s0.1,0.1,0.2,0.1s0.2,0,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3 L17.9,20.9L17.9,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.9,20.3l-1.1-1l0.4-0.4c0.1-0.2,0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2c0.2,0.1,0.2,0.3,0.3,0.5 c0,0.2,0,0.3-0.1,0.5L19.9,20.3L19.9,20.3z M19.9,20.1l0.2-0.2c0.1-0.1,0.2-0.2,0.1-0.4c0-0.1-0.1-0.3-0.2-0.4s-0.2-0.2-0.4-0.2 c-0.1,0-0.3,0-0.4,0.1L19,19.2L19.9,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.5,18.2l0.1,0.1L21,19.1l-1.2-0.9l0.6-0.8l0.1,0.1L20,18.1l0.4,0.3l0.4-0.5l0.1,0.1l-0.4,0.5l0.4,0.3 L21.5,18.2L21.5,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.4,17.9v-0.2c0.2,0,0.4,0,0.5-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0 s-0.1,0.1-0.1,0.1l-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1s-0.1,0-0.2,0s-0.1,0-0.2-0.1s-0.2-0.1-0.2-0.3c0-0.1,0-0.2,0.1-0.4 c0.1-0.2,0.3-0.3,0.6-0.3v0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.2c0,0.1-0.1,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2s0.2,0,0.3-0.1 l0.2-0.2c0.2-0.2,0.4-0.2,0.6-0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4C21.9,17.8,21.7,17.9,21.4,17.9L21.4,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.6,16.4l-0.1,0.2L21.1,16l0.1-0.2L22.6,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.4,14.6l0.8,0.2v0.1H23c0.1,0.1,0.1,0.3,0.1,0.5c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0 s-0.4-0.2-0.5-0.3c-0.1-0.2-0.1-0.3-0.1-0.5c0.1-0.3,0.3-0.4,0.6-0.4v0.2c-0.1,0-0.2,0-0.3,0.1s-0.1,0.1-0.1,0.2 c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.3,0.1,0.5,0s0.2-0.1,0.3-0.3c0-0.1,0-0.2,0-0.3s-0.1-0.2-0.3-0.2 c0,0,0,0-0.1,0l-0.1,0.4h-0.2L22.4,14.6L22.4,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.4,13.2v0.2L21.9,14H22h0.1l1.1,0.2v0.2l-1.5-0.2V14l1.3-0.6h-0.1h-0.1l-1-0.1v-0.1L23.4,13.2L23.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.2,11.1h0.2V12h-1.5v-0.2l1.3-0.1C23.2,11.8,23.2,11.1,23.2,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.1,9.7v0.2l-0.4,0.2l0.1,0.6l0.5,0.1V11l-1.6-0.2v-0.2L23.1,9.7L23.1,9.7z M22.6,10.1l-0.7,0.4l0.8,0.1 L22.6,10.1L22.6,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23,9.3l-1.4,0.5l-0.2-0.6c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.2-0.2c0.2-0.1,0.3,0,0.4,0.2 c0-0.1,0-0.2,0.1-0.3s0.1-0.1,0.2-0.1s0.2,0,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3L23,9.3z M22.1,9.4L22,9.1c0-0.1-0.1-0.2-0.2-0.2 s-0.1,0-0.2,0S21.5,9,21.5,9c0,0.1,0,0.1,0,0.2l0.1,0.4L22.1,9.4z M22.8,9.2l-0.1-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1,0-0.2,0 s-0.1,0-0.1,0.1l-0.1,0.1c0,0,0,0.1,0,0.2l0.1,0.4L22.8,9.2L22.8,9.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M8.5,5.4h0.7v5H8.5V5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M10,5.4h0.7v4.3h1v0.7H10C10,10.3,10,5.4,10,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12.1,10.3v-5h0.6c0.7,0,1,0.1,1.2,0.5s0.2,1,0.2,2s0,1.6-0.2,2s-0.6,0.5-1.2,0.5H12.1L12.1,10.3z M12.9,9.6 c0.2,0,0.4,0,0.5-0.3c0-0.1,0.1-0.3,0.1-0.5s0-0.6,0-1s0-0.7,0-1c0-0.2,0-0.4-0.1-0.5C13.3,6.1,13.2,6,12.9,6 C12.9,6.1,12.9,9.6,12.9,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.8,5.4h0.7v4.3h1v0.7h-1.7V5.4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.1,13c0.1,0,0.1-0.1,0.2-0.2l0,0l0.2,0.1l0.1-0.1l-0.2-0.1l0,0c0-0.1,0.1-0.2,0.1-0.3l0,0l0.2-0.1v-0.2h-0.2 l0,0c0-0.1-0.1-0.2-0.1-0.2l0,0l0.1-0.2l-0.1-0.1l-0.2,0.1l0,0c-0.1,0-0.2-0.1-0.2-0.1l0,0v-0.2h-0.2l-0.1,0.2l0,0h-0.1 c-0.1,0-0.1,0-0.2,0.1l0,0l-0.1-0.1l-0.1,0.1l0.1,0.2l0,0c-0.1,0.1-0.1,0.1-0.1,0.2l0,0H18v0.2l0.2,0.1l0,0c0,0.1,0,0.1,0,0.2l0,0 l0,0L18,12.7l0.1,0.2l0.2-0.1l0,0c0.1,0.1,0.1,0.1,0.2,0.2l0,0l-0.1,0.2l0.2,0.1l0.1-0.2l0,0c0.1,0,0.2,0,0.3,0l0,0l0.1,0.2h0.2 L19.1,13L19.1,13L19.1,13z M18.9,12.9l-0.1-0.3c0.1,0,0.1-0.1,0.1-0.2l0.3-0.1C19.3,12.5,19.2,12.8,18.9,12.9L18.9,12.9z M19.2,12.2 l-0.3,0.1c0-0.1-0.1-0.1-0.2-0.1l-0.1-0.3C18.9,11.8,19.1,11.9,19.2,12.2L19.2,12.2z M18.7,12.4c0,0,0-0.1,0.1-0.1s0.1,0,0.1,0.1 c0,0,0,0.1-0.1,0.1S18.7,12.4,18.7,12.4z M18.5,11.9l0.1,0.3c-0.1,0-0.1,0.1-0.1,0.2l-0.3,0.1C18.2,12.2,18.3,12,18.5,11.9 L18.5,11.9z M18.2,12.6l0.3-0.1c0,0.1,0.1,0.1,0.2,0.1l0.1,0.3C18.6,12.9,18.3,12.8,18.2,12.6L18.2,12.6z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M4.6,11.8c0,0-0.7,4.1,2.7,4.3C7.3,16.1,9,12.8,4.6,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.5,13.2c0,0-1.8,0.5-1.1,2.5C8.4,15.7,10.4,15.1,9.5,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.7,13.2c0,0,2.1,3,2,4.7c0,0,0.4-1.8,1.3-3.3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 4.9,
    cy: 10,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 5.8,
    cy: 8.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 7.4,
    cy: 6.3,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 7.3,
    cy: 8.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 6.5,
    cy: 10,
    r: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 7.4,
    y1: 6.3,
    x2: 7.3,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 5.8,
    y1: 8.4,
    x2: 7.3,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 5.8,
    y1: 8.4,
    x2: 6.5,
    y2: 9.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 4.9,
    y1: 10,
    x2: 5.8,
    y2: 8.4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 19.6,
    cy: 10,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 18.6,
    cy: 8.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 17.1,
    cy: 6.3,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 17.1,
    cy: 8.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 17.9,
    cy: 10,
    r: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 17.1,
    y1: 6.3,
    x2: 17.1,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 18.6,
    y1: 8.4,
    x2: 17.1,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 18.6,
    y1: 8.4,
    x2: 17.9,
    y2: 9.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 19.6,
    y1: 10,
    x2: 18.6,
    y2: 8.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIldlLogo);
export default __webpack_public_path__ + "static/media/ILDL-logo.648802b4.svg";
export { ForwardRef as ReactComponent };